import React from "react";
import { HStack } from "@chakra-ui/react";
import { format } from "date-fns";
import { DatePicker } from "components";
import { useQueryParams } from "duck";

const Filter: React.FC = () => {
  const [params, setParams] = useQueryParams();

  const dateFrom = params.filter?.dateFrom;
  const dateTo = params.filter?.dateTo;

  return (
    <HStack spacing="24px" w="max-content">
      <DatePicker
        label="Access log from"
        placeholderText="Date From"
        labelHidden
        isClearable
        value={dateFrom ? new Date(dateFrom) : null}
        onChange={value => {
          const newDate = value && format(value, "MM/dd/y");

          setParams({
            ...params,
            filter: { ...params.filter, dateFrom: newDate },
            pagination: { page: 1 }
          });
        }}
      />
      <DatePicker
        label="Access log to"
        placeholderText="Date To"
        labelHidden
        isClearable
        value={dateTo ? new Date(dateTo) : null}
        onChange={value => {
          const newDate = value && format(value, "MM/dd/y");

          setParams({
            ...params,
            filter: { ...params.filter, dateTo: newDate },
            pagination: { page: 1 }
          });
        }}
      />
    </HStack>
  );
};

export default Filter;
